import React from 'react';

export const UncheckedIcon = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#A9AFBC" />
    </svg>
  );
};
